import React, { useEffect, useState } from 'react'
import { Dimensions, FlatList, StyleSheet, Text, TextInput, TouchableOpacity, View, Image } from 'react-native'
import { getConection } from '../appBar/context/HeaderContext'
import { fetchAuthSession } from 'aws-amplify/auth'
import { request_get_schedule_period, request_update_schedule_periods } from '../../services/schedule.services'
import { FlashList } from '@shopify/flash-list'
import { Loader } from '../customUtils/Components/Loader'
import { STATUS_PERIOD, STATUS_KEYS, STATUS_MODERATION, PERIOD_SEND_TYPE } from './constants/constants.stores'
import * as Progress from 'react-native-progress'
import { useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { DotsNavigation } from '../navigation/stacks/NavigationStack'
import { useBottomSheet } from '../customUtils/context/BottomSheetContext'
import { getLanguage } from '../appBar/context/LocalizationContext'
import styles from './CreateScheduleStyles'
import theme from '../../../theme'
import { AntDesign, Feather, Ionicons } from '@expo/vector-icons'
import { colorFilled, colorUnfilled } from '../../../themeConstants'
import { CreateScheduleWeek } from './CreateScheduleWeek'
import { ScrollView } from 'react-native-gesture-handler'
import { BottomSheetAlert } from '../modals/BottomSheetAlert'
import { Calendar } from 'react-native-calendars'

const { width } = Dimensions.get('window')

import moment from 'moment' // Necesitarás importar moment o usar Date para comparar las fechas
import { CreateScheduleMonth } from './CreateScheduleMonth'
import { CreateScheduleSingleModel, Period, Distributor, Activity, Day, Week } from './models/CreateScheduleModel'

export const CreateSchedule = ({ route }) => {
    let week_id = route.params?.week_id ?? null
    let period_id = route.params?.period_id ?? null
    const { languageFile } = getLanguage()
    const { isConnected, hasInternet } = getConection()
    const [loading, setLoading] = useState(true)
    const [distributors, setDistributors] = useState<Distributor[]>([])
    const [filteredDistributors, setFilteredDistributors] = useState<Distributor[]>([])
    const [searchText, setSearchText] = useState<string>('')
    const [period, setPeriod] = useState<Period>({ _id: '', status: -1 })
    const navigation = useNavigation<StackNavigationProp<DotsNavigation>>()
    const { openBottomSheet, closeBottomSheet } = useBottomSheet()
    const [arrayDistributorsSelected, setArrayDistributorsSelected] = useState<string[]>([])
    const [activities, setActivities] = useState<Activity[]>([])
    const [distributor_activities, setDistributorActivities] = useState<Activity[]>([])
    const [monthly_distributor_activities, setMonthlyDistributorActivities] = useState<Activity[]>([])
    const [monthly_activities, setMonthlyActivities] = useState<Activity[]>([])
    const [selectedWeek, setSelectedWeek] = useState<number>(0)
    const [indexDay, setIndexDay] = useState(0)

    useEffect(() => {
        fetchData()
    }, [])

    const getTitleAndSubtitle = (status: number) => {
        const currentDate = new Date()
        const monthNames = [
            'Enero',
            'Febrero',
            'Marzo',
            'Abril',
            'Mayo',
            'Junio',
            'Julio',
            'Agosto',
            'Septiembre',
            'Octubre',
            'Noviembre',
            'Diciembre',
        ]
        const currentMonth = monthNames[currentDate.getMonth()]
        const currentYear = currentDate.getFullYear()

        switch (status) {
            case -1:
                return { title: '', subtitle: '' }
            case STATUS_PERIOD.PENDING_SET_DISTRIBUTORS:
                return {
                    title: `${currentMonth} ${currentYear}`,
                    subtitle: 'Selecciona tus distribuidoras sobre las que trabajarás en el próximo mes.',
                }
            case STATUS_PERIOD.PENDING_CHANGE_REQUIRED_DISTRIBUTORS:
                return {
                    title: '¡Tienes modificaciones en tu agenda!',
                    subtitle: 'Realiza los cambios y vuelve a enviarlos. Recibirás una notificación cuando tu agenda sea aprobada o rechazada.',
                }
            case STATUS_PERIOD.PENDING_APPROBB_DISTRIBUTORS:
                return {
                    title: 'Tu agenda está en período de validación',
                    subtitle: '¡Pronto recibirás una devolución! Una vez aprobado tu mes, podrás armar las agendas semanales.',
                }
            default:
                return { title: '', subtitle: '' }
        }
    }
    let { title, subtitle } = getTitleAndSubtitle(period.status ?? -1)
    let maxToSend = period.distributors_max ?? 9
    let rejectedDistributors = distributors.filter((distributor) => distributor.status == -1).length
    let distributorProgress = ((arrayDistributorsSelected.length - rejectedDistributors) * 100) / maxToSend

    let sendType = period.status == STATUS_PERIOD.PERIOD_APROBB ? PERIOD_SEND_TYPE.WEEKLY : PERIOD_SEND_TYPE.MONTHLY // Por defecto dejarlo seteado en mensual

    const fetchData = async () => {
        try {
            if (isConnected && hasInternet) {
                const session = await fetchAuthSession()
                const authToken = session.tokens?.accessToken?.toString() || ""
                const data: CreateScheduleSingleModel = await request_get_schedule_period({ authToken })
                if (!data) {
                    setLoading(false)
                    return
                }
                if (data.periods && data.periods.length > 0) {
                    const period = data.periods.find((period) => period._id.toString() === period_id.toString())

                    // let period = data.period

                    if (
                        period.status == STATUS_PERIOD.PENDING_SET_DISTRIBUTORS ||
                        period.status == STATUS_PERIOD.PENDING_CHANGE_REQUIRED_DISTRIBUTORS ||
                        period.status == STATUS_PERIOD.PENDING_APPROBB_DISTRIBUTORS
                    ) {
                        let periodDistributors = period.distributors ?? []
                        let Datadistributors = data.distributors.map((distributor) => {
                            return { ...distributor, status: 0 }
                        })
                        let DefaultSelected = periodDistributors.map((distributor) => distributor._id)
                        setArrayDistributorsSelected(DefaultSelected)
                        const allDistributors = periodDistributors.concat(Datadistributors)
                        setDistributors(allDistributors)
                        setFilteredDistributors(allDistributors)
                        setPeriod(data.period)
                    } else if (period.status === STATUS_PERIOD.PENDING_SET_MONTHS || period.status === STATUS_PERIOD.PERIOD_APROBB) {
                        setDistributorActivities(data.distributor_activities ?? []) //Actividades de distribuidor
                        setActivities(data.activities) //Otras actividades
                        setMonthlyActivities(data.monthly_activities ?? []) //Otras actividades mensuales
                        let monthly_activities = data.monthly_distributor_activities ?? []
                        let monthActs = monthly_activities.map((activity) => {
                            return { ...activity, related_distributors: [] }
                        })
                        setMonthlyDistributorActivities(monthActs ?? []) //Actividades mensuales de distribuidor
                        const today = new Date() // Fecha actual
                        today.setUTCHours(0, 0, 0, 0) // Establecer la hora a las 00:00 en UTC
                        const updatedWeeks = period.weeks.map((week) => {
                            const updatedDays = week.days.map((day) => {
                                const dateFromObject = new Date(day.date)
                                day.previous_day = dateFromObject < today

                                if (day.distributor != null) {
                                    let distributor = period.distributors.find((distributor) => distributor._id === day.distributor._id)
                                    if (distributor) {
                                        distributor.status = day.distributor.status
                                        day.distributor = distributor
                                    }
                                }
                                //Otras actividades
                                if (day.activities && day.activities.length > 0) {
                                    day.activities = day.activities.map((activity) => {
                                        let act = data.activities.find((a) => a._id === activity._id)
                                        if (act) {
                                            return { ...act, status: activity.status != -1 ? activity.status : 0 }
                                        }
                                        return activity
                                    })
                                } else {
                                    day.activities = []
                                }
                                //Actividades de distribuidor
                                if (day.distributor_activities && day.distributor_activities.length > 0) {
                                    day.distributor_activities = day.distributor_activities.map((activity) => {
                                        let act = data.distributor_activities.find((a) => a._id === activity._id)
                                        if (act) {
                                            return { ...act, status: activity.status != -1 ? activity.status : 0 }
                                        }
                                        return activity
                                    })
                                } else {
                                    day.distributor_activities = []
                                }
                                //Otras ctividades mensuales
                                if (day.monthly_activities && day.monthly_activities.length > 0) {
                                    day.monthly_activities = day.monthly_activities.map((activity) => {
                                        let act = data.monthly_activities.find((a) => a._id === activity._id)
                                        if (act) {
                                            return { ...act, status: activity.status ? activity.status : 1 }
                                        }
                                        return activity
                                    })
                                } else {
                                    day.monthly_activities = []
                                }
                                //Actividades mensuales de distribuidor
                                if (day.monthly_distributor_activities && day.monthly_distributor_activities.length > 0) {
                                    day.monthly_distributor_activities = day.monthly_distributor_activities.map((activity) => {
                                        let act = data.monthly_distributor_activities.find((a) => a._id.toString() == activity._id.toString())
                                        if (act) {
                                            return { ...act, status: activity.status != -1 ? activity.status : 0 }
                                        }
                                        return activity
                                    })
                                } else {
                                    day.monthly_distributor_activities = []
                                }
                                return day
                            })
                            return { ...week, days: updatedDays }
                        })
                        if (week_id != null) {
                            let selectedWeek = period.weeks.findIndex((week) => week._id == week_id)
                            if (selectedWeek == -1) {
                                selectedWeek = 0
                            }
                            setSelectedWeek(selectedWeek)
                            findFirstDay(period.weeks[selectedWeek].days)
                        } else {
                            // recorro las semanas para encontrar la primera que tenga un dia que no sea de otro mes
                            let workingWeek = period.weeks.findIndex((week) => {
                                return week.days.some((day) => {
                                    return day.status != STATUS_PERIOD.STATUS_DAY_OTHER_MONTH
                                })
                            })
                            if (workingWeek != -1) setSelectedWeek(workingWeek)
                            console.log('HOLADEM', workingWeek)
                            findFirstDay(period.weeks[workingWeek].days)
                        }
                        setPeriod({ ...period, weeks: updatedWeeks })
                    }
                }

                setLoading(false)
            }
        } catch (error) {
            console.log('error', error)
            setLoading(false)
        }
    }

    const setSelectedDistributors = (id: string, array: string[]) => {
        console.log('entro', id)
        if (array.includes(id)) {
            console.log('Tengo el id', array)
            setArrayDistributorsSelected(array.filter((item) => item !== id))
        } else {
            if (array.length - rejectedDistributors < maxToSend) {
                setArrayDistributorsSelected([...array, id])
            }
        }
    }
    const findFirstDay = (days: Day[]) => {
        if (!days) {
            return
        }
        let dayIndex = days.findIndex((day) => day.status != STATUS_PERIOD.STATUS_DAY_OTHER_MONTH && !day.previous_day)
        if (dayIndex == -1) {
            dayIndex = days.findIndex((day) => day.status != STATUS_PERIOD.STATUS_DAY_OTHER_MONTH)
        }

        if (dayIndex == -1) {
            dayIndex = 0
        }
        setIndexDay(dayIndex)
    }
    const onChangeText = (text: string) => {
        setSearchText(text)
        filterText(distributors, text)
    }

    const filterText = (data: Distributor[], text: string) => {
        if (!data || text.length == 0) {
            setFilteredDistributors(data)
            return
        }

        const filter = data.filter((item) => item.name && item.name.toLowerCase().includes(text.toLowerCase()))
        setFilteredDistributors(filter)
    }
    const showButtonSend = () => {
        let show = true
        if (period.status == STATUS_PERIOD.PERIOD_APROBB) {
            let allWeeksOk = period.weeks.every((week) => week.status == STATUS_PERIOD.PERIOD_APROBB)
            if (allWeeksOk) {
                show = true // false si no deben editar constantemente
            }
            if (period.weeks[selectedWeek].status != 3) {
                const today = new Date() // Fecha actual
                today.setUTCHours(0, 0, 0, 0) // Establecer la hora a las 00:00 en UTC
                const dateFinish = new Date(period.weeks[selectedWeek].date_finish) // Fecha de finalización de la semana
                dateFinish.setUTCHours(0, 0, 0, 0) // Establecer la hora a las 00:00 en UTC
                if (dateFinish < today) {
                    show = false
                }
            }
        }

        return show
    }
    const enableButtonSend = () => {
        let enable = false
        if (period.status == STATUS_PERIOD.PENDING_SET_DISTRIBUTORS || period.status == STATUS_PERIOD.PENDING_CHANGE_REQUIRED_DISTRIBUTORS) {
            if (arrayDistributorsSelected.length - rejectedDistributors == maxToSend) {
                enable = true
            }
        }
        if (period.status == STATUS_PERIOD.PERIOD_APROBB || period.status == STATUS_PERIOD.PENDING_SET_MONTHS) {
            switch (sendType) {
                case PERIOD_SEND_TYPE.WEEKLY:
                    // Validación por semana
                    let currentWeek = period.weeks[selectedWeek]
                    let weekComplete = true
                    weekComplete = validateWeekComplete(currentWeek, period.status)
                    let allVacation = currentWeek.days.every((day) => {
                        return day.status == STATUS_PERIOD.VACATION
                    })
                    if (allVacation) {
                        weekComplete = true
                    }
                    if (weekComplete && currentWeek.status != STATUS_PERIOD.PERIOD_APROBB) {
                        weekComplete = true
                    }
                    if (currentWeek.status == STATUS_PERIOD.PENDING_APPROBB_WEEKS) {
                        weekComplete = false
                    }

                    if (currentWeek.status == 1) {
                        weekComplete = true // Para no volver a enviar como ejecutivo cuando ya esta aprobado va en false
                    }
                    enable = weekComplete
                    break
                case PERIOD_SEND_TYPE.DAILY:
                    // Validación por día
                    //A definir
                    enable = true
                    break
                default:
                    //Mes
                    // Validación por mes
                    // Valido tener distribuidores
                    let allComplete = true
                    const allWeeks = period.weeks.forEach((week) => {
                        let weekComplete = true
                        weekComplete = validateWeekCompleteNoActivities(week)
                        if (weekComplete && week.status != STATUS_PERIOD.PERIOD_APROBB) {
                            weekComplete = true
                        }
                        if (week.status == STATUS_PERIOD.PENDING_APPROBB_WEEKS) {
                            weekComplete = false
                        }
                        if (weekComplete == false) {
                            allComplete = false
                        }
                    })
                    enable = allComplete
                    break
            }
        }
        return enable
    }
    const sendStep = async () => {
        try {
            if (isConnected && hasInternet) {
                const session = await fetchAuthSession()
                const authToken = session.tokens?.accessToken?.toString() || ""
                let body = {}

                if (period.status == STATUS_PERIOD.PENDING_SET_DISTRIBUTORS || period.status == STATUS_PERIOD.PENDING_CHANGE_REQUIRED_DISTRIBUTORS) {
                    const distributorsToSend = distributors.filter((distributor) => arrayDistributorsSelected.includes(distributor._id))
                    body = {
                        key: STATUS_KEYS.KEY_DISTRIBUTOR,
                        period_id: period._id,
                        data: distributorsToSend,
                    }

                    const data = await request_update_schedule_periods({ authToken, body })

                    if (!data) {
                        return
                    }
                    console.log('DATA', JSON.stringify(data))
                    if (data.status == 1) {
                        // openSentDistributorsSheet()
                        fetchData()
                    }
                }

                if (period.status == STATUS_PERIOD.PERIOD_APROBB || period.status == STATUS_PERIOD.PENDING_SET_MONTHS) {
                    let key = ''
                    let info = []
                    switch (sendType) {
                        case PERIOD_SEND_TYPE.WEEKLY:
                            key = STATUS_KEYS.KEY_SET_WEEKS
                            info = [
                                {
                                    _id: period.weeks[selectedWeek]._id,
                                    days: period.weeks[selectedWeek].days.map((day) => {
                                        if (day.status != STATUS_MODERATION.VACATION) {
                                            if (day.distributor == null) {
                                                return {
                                                    _id: day._id,
                                                    status: 0,
                                                    status_day: day.status != 0 && day.status != 8 ? day.status : 4,
                                                    activities:
                                                        day.activities.map((a) => {
                                                            return { _id: a._id, status: a.status ? a.status : 0 }
                                                        }) ?? [],
                                                    distributor_activities:
                                                        day.distributor_activities.map((a) => {
                                                            return { _id: a._id, status: a.status ? a.status : 0 }
                                                        }) ?? [],
                                                    monthly_distributor_activities:
                                                        day.monthly_distributor_activities.map((a) => {
                                                            return { _id: a._id, status: a.status ? a.status : 0 }
                                                        }) ?? [],
                                                }
                                            } else {
                                                return {
                                                    _id: day._id,
                                                    distributor_id: day.distributor._id,
                                                    status: day.distributor.status,
                                                    status_day: day.status != 0 && day.status != 8 ? day.status : 4,
                                                    activities:
                                                        day.activities.map((a) => {
                                                            return { _id: a._id, status: a.status ? a.status : 0 }
                                                        }) ?? [],
                                                    monthly_distributor_activities:
                                                        day.monthly_distributor_activities.map((a) => {
                                                            return { _id: a._id, status: a.status ? a.status : 0 }
                                                        }) ?? [],
                                                    monthly_activities:
                                                        day.monthly_activities.map((a) => {
                                                            return { _id: a._id, status: a.status ? a.status : 0 }
                                                        }) ?? [],
                                                    distributor_activities:
                                                        day.distributor_activities.map((a) => {
                                                            return { _id: a._id, status: a.status ? a.status : 0 }
                                                        }) ?? [],
                                                }
                                            }
                                        } else {
                                            return {
                                                _id: day._id,
                                                status: 0,
                                                status_day: day.status,
                                                distributor_id: null,
                                                activities: [],
                                                monthly_activities:
                                                    day.monthly_activities.map((a) => {
                                                        return { _id: a._id, status: a.status ? a.status : 0 }
                                                    }) ?? [],
                                                distributor_activities: [],
                                                monthly_distributor_activities: [],
                                            }
                                        }
                                    }),
                                },
                            ]
                        case PERIOD_SEND_TYPE.DAILY:
                            //A definir
                            break
                        default:
                            //Mensual
                            key = STATUS_KEYS.KEY_SET_MONTHS
                            info = period.weeks.map((week) => {
                                return {
                                    _id: week._id,
                                    days: week.days.map((day) => {
                                        if (day.status != STATUS_MODERATION.VACATION) {
                                            if (day.distributor == null) {
                                                return {
                                                    _id: day._id,
                                                    status: 0,
                                                    status_day: day.status != 0 && day.status != 8 ? day.status : 4,
                                                    monthly_activities:
                                                        day.monthly_activities.map((a) => {
                                                            return { _id: a._id, status: a.status ? a.status : 0 }
                                                        }) ?? [],
                                                    monthly_distributor_activities:
                                                        day.monthly_distributor_activities.map((a) => {
                                                            return { _id: a._id, status: a.status ? a.status : 0 }
                                                        }) ?? [],
                                                }
                                            } else {
                                                return {
                                                    _id: day._id,
                                                    distributor_id: day.distributor._id,
                                                    status: day.distributor.status,
                                                    status_day: day.status != 0 && day.status != 8 ? day.status : 4,
                                                    monthly_activities:
                                                        day.monthly_activities.map((a) => {
                                                            return { _id: a._id, status: a.status ? a.status : 0 }
                                                        }) ?? [],
                                                    monthly_distributor_activities:
                                                        day.monthly_distributor_activities.map((a) => {
                                                            return { _id: a._id, status: a.status ? a.status : 0 }
                                                        }) ?? [],
                                                }
                                            }
                                        } else {
                                            return {
                                                _id: day._id,
                                                status: 0,
                                                status_day: day.status,
                                                activities: [],
                                                distributor_activities: [],
                                                monthly_distributor_activities: [],
                                                monthly_activities:
                                                    day.monthly_activities.map((a) => {
                                                        return { _id: a._id, status: a.status ? a.status : 0 }
                                                    }) ?? [],
                                                distributor_id: null,
                                            }
                                        }
                                    }),
                                }
                            })
                    }

                    body = {
                        key: key,
                        period_id: period._id,
                        data: info,
                    }
                    console.log('esto mando', JSON.stringify(body))

                    const data = await request_update_schedule_periods({ authToken, body })
                    console.log('DATA', JSON.stringify(data))

                    if (!data) {
                        return
                    }

                    if (data.status == 1) {
                        setIndexDay(0)
                        if (sendType == PERIOD_SEND_TYPE.WEEKLY) {
                            // let weekUpdate = data.single.period.weeks.find((w) => w._id.toString() == period.weeks[selectedWeek]._id.toString())

                            // period.weeks[selectedWeek].days = period.weeks[selectedWeek].days.map((d) => {
                            //     let matchingDay = weekUpdate.days.find((d2) => d2._id.toString() == d._id.toString())

                            //     // Si se encuentra un día coincidente en `weekUpdate`, actualiza el status
                            //     if (matchingDay) {
                            //         return {
                            //             ...d,
                            //             status: matchingDay.status,
                            //         }
                            //     }

                            //     // Si no se encuentra, retorna el día original sin cambios
                            //     return d
                            // })

                            // period.weeks[selectedWeek].status = weekUpdate.status
                            //openSentWeekSheet()
                            closeBottomSheet(true)
                            navigation.goBack()
                        } else {
                            openSentMonthSheet()
                        }
                        // closeBottomSheet(true)
                    }
                }
            }
        } catch (error) {
            console.error('sendStep error =>', error)
        }
    }

    const sendVacations = async (days) => {
        try {
            if (isConnected && hasInternet) {
                const session = await fetchAuthSession()
                const authToken = session.tokens?.accessToken?.toString() || ""
                let body = {}

                let info = []
                days.forEach((d) => {
                    info.push({
                        date_init: `${d}`,
                        date_finish: `${d}`,
                    })
                })

                body = {
                    key: STATUS_KEYS.KEY_SET_VACATIONS,
                    period_id: period._id,
                    data: info,
                }

                // console.log("body : " , JSON.stringify(body))

                const data = await request_update_schedule_periods({ authToken, body })

                period.vacations = data.single.period.vacations
                // console.log("data : " , JSON.stringify(data))
                closeBottomSheet(true)
            }
        } catch (error) {}
    }

    let buttonEnabled = enableButtonSend()
    let showButton = showButtonSend()
    const openFilters = () => {
        openBottomSheet(<DistributorFilters filterList={filterList} />)
    }

    const openSentDistributorsSheet = () => {
        const isModalClosable = false
        const isModalClosableTouch = false
        const isModalClosableSlice = false
        openBottomSheet(
            <DistributorsSentModal
                close={() => {
                    closeBottomSheet(true)
                    navigation.goBack()
                }}
            />,
            isModalClosable,
            isModalClosableTouch,
            isModalClosableSlice,
        )
    }
    const openSentWeekSheet = () => {
        const isModalClosable = false
        const isModalClosableTouch = false
        const isModalClosableSlice = false
        const keyboardShouldPersistTaps = true
        openBottomSheet(
            <SentWeekModal
                close={(I) => {
                    // let newIndex = selectedWeek + 1
                    // if (period.weeks[newIndex]) {
                    //     setSelectedWeek(newIndex)
                    //     setIndexDay(0)
                    // } else {
                    navigation.goBack()
                    // }
                    closeBottomSheet(true)
                }}
                week={period.weeks[selectedWeek].name_week ?? ''}
                closeBottomSheet={() => closeBottomSheet(true)}
            />,
            undefined, //snap
            undefined, //keyboard
            isModalClosable,
            isModalClosableTouch,
            isModalClosableSlice,
        )
    }
    const openSentMonthSheet = () => {
        const isModalClosable = false
        const isModalClosableTouch = false
        const isModalClosableSlice = false
        const keyboardShouldPersistTaps = true
        openBottomSheet(
            <SentMonthModal
                close={() => {
                    // let newIndex = selectedWeek + 1
                    // if (period.weeks[newIndex]) {
                    //     setSelectedWeek(newIndex)
                    //     setIndexDay(0)
                    // } else {
                    navigation.goBack()
                    // }
                    closeBottomSheet(true)
                }}
            />,
            undefined, //snap
            undefined, //keyboard
            isModalClosable,
            isModalClosableTouch,
            isModalClosableSlice,
        )
    }
    if (loading) {
        return <Loader />
    }

    const filterList = (filter: number) => {
        if (filter == -1) {
            return
        }
        if (filter == 1) {
            let sorted = filteredDistributors.sort((a, b) => a.name.localeCompare(b.name))
            filterText(sorted, searchText)
            closeBottomSheet(true)
        }
        if (filter == 2) {
            let sorted = filteredDistributors.sort((a, b) => b.name.localeCompare(a.name))
            filterText(sorted, searchText)
            closeBottomSheet(true)
        }
    }

    // Setea el periodo y updatea los dias con lo seleccionado
    const updatePeriod = (period: Period) => {
        // console.log('605 -- updatePeriod', JSON.stringify(period))
        setPeriod(period)
    }
    const updateMonthlyDistributorActivities = (acts: Activity[]) => {
        setMonthlyDistributorActivities(acts)
    }
    const updateMonthlyActivities = (acts: Activity[]) => {
        setMonthlyActivities(acts)
    }
    const setWeek = (index: number) => {
        let newIndex = selectedWeek + index
        if (period.weeks[newIndex]) {
            setSelectedWeek(newIndex)
            findFirstDay(period.weeks[newIndex].days)
        } else {
            setSelectedWeek(0)
            findFirstDay(period.weeks[selectedWeek].days)
        }
    }
    const sendButtonText = () => {
        let buttonText = languageFile.send + ' y continuar'
        if (period.status == STATUS_PERIOD.PERIOD_APROBB) {
            buttonText = languageFile.send + ' ' + (sendType == PERIOD_SEND_TYPE.WEEKLY ? period.weeks[selectedWeek].name_week ?? 'semana' : '')
        }
        return buttonText
    }
    const openVacationModal = () => {
        openBottomSheet(
            <AddVacationModal
                close={() => closeBottomSheet(true)}
                onSave={(days) => sendVacations(days)}
                customDate={period.date_init}
                maxDate={period.date_finish}
                initialSelectedDays={period.vacations}
            />,
        )
    }
    let buttonText = sendButtonText()
    let locked = period.status == STATUS_PERIOD.PENDING_APPROBB_DISTRIBUTORS ? true : false
    let lockedExecutive =
        period.weeks[selectedWeek].status == 4
            ? true
            : false || period.weeks[selectedWeek].days[indexDay].status == 12
            ? true
            : false || period.weeks[selectedWeek].status == 1
            ? false
            : false
    let vacationDaysText = period.vacations && period.vacations.length > 0 ? 'Ver vacaciones' : 'Cargar vacaciones'
    let nextDayText = 'Siguiente día'
    let seeVacations = period.vacations && period.vacations.length > 0 ? true : false
    const LAST_DAY_WEEK = 5

    const setIndexDayFn = (index: number) => {
        if (!period || !period.weeks || !period.weeks[selectedWeek]) {
            return
        }

        const days = period.weeks[selectedWeek]['days']
        if (!Array.isArray(days) || index < 0 || index >= days.length) {
            return
        }

        const day = days[index]
        if (!day || day.status === STATUS_PERIOD.STATUS_DAY_OTHER_MONTH) {
            return
        }

        setIndexDay(index)
    }

    const onPressNextDay = () => {
        if (indexDay === LAST_DAY_WEEK) {
            if (period.status === STATUS_PERIOD.PENDING_SET_MONTHS) {
                setIndexDay(0)
                setWeek(1)
                return
            }
        }

        let newIndex = indexDay + 1
        if (period.weeks[selectedWeek].days[newIndex] && period.weeks[selectedWeek].days[newIndex].status !== STATUS_PERIOD.STATUS_DAY_OTHER_MONTH) {
            setIndexDay(newIndex)
        } else {
            setIndexDay(0)
        }
    }

    return (
        <View style={styles.container}>
            <ScrollView showsVerticalScrollIndicator={false} nestedScrollEnabled={true} style={{ marginBottom: 60 }}>
                <View style={styles.spacer1}></View>
                {title && <Text style={[styles.section, styles.marginRight]}>Planificación mensual</Text>}
                {title && <View style={styles.spacer}></View>}
                {title && <Text style={styles.title}>{title}</Text>}
                <View style={styles.spacer1}></View>
                <View style={styles.spacer1}></View>
                {subtitle && <Text style={[styles.subtitle, styles.marginRight]}>{subtitle}</Text>}
                <View style={styles.spacer1}></View>
                <View style={styles.spacer1}></View>
                <View style={styles.spacer1}></View>
                {(() => {
                    switch (period.status) {
                        case STATUS_PERIOD.PENDING_SET_DISTRIBUTORS:
                        case STATUS_PERIOD.PENDING_CHANGE_REQUIRED_DISTRIBUTORS:
                        case STATUS_PERIOD.PENDING_APPROBB_DISTRIBUTORS:
                            return (
                                <View style={styles.container}>
                                    {/*<View style={[styles.containerRow, styles.marginRight, { justifyContent: 'space-between' }]}>
                                        <Text style={styles.title}></Text>
                                    </View>
                                    <View style={styles.spacer1}></View>*/}

                                    <Progress.Bar
                                        progress={distributorProgress / 100}
                                        height={8}
                                        width={width - 24}
                                        style={styles.progressBar}
                                        color={colorFilled}
                                        unfilledColor={colorUnfilled}
                                    />

                                    <View style={styles.spacer}></View>
                                    <View style={styles.spacer1}></View>

                                    <View style={[styles.containerRow, { justifyContent: 'space-between' }]}>
                                        <View style={styles.containerRow}>
                                            <Text style={styles.distributor}>{'Distribuidoras seleccionadas: '}</Text>
                                            <Text style={styles.number}>
                                                {arrayDistributorsSelected.length - rejectedDistributors}/{maxToSend}
                                            </Text>
                                        </View>
                                        {/*<View style={[styles.containerRow, { marginRight: 12 }]}>
                                            <Text style={styles.distributor}>{'Rechazadas: '}</Text>
                                            <Text style={styles.number}>{rejectedDistributors}</Text>
                                        </View>*/}
                                    </View>
                                    <View style={styles.spacer1}></View>
                                    <View style={styles.containerFinder}>
                                        <View style={styles.inputBlock}>
                                            <TextInput
                                                style={styles.input}
                                                onChangeText={onChangeText}
                                                placeholder={'Buscar distribuidor'}
                                                placeholderTextColor={theme.colors.mediumGray}
                                            />

                                            <Feather name='search' size={24} color={theme.colors.colorPrimary} />
                                        </View>
                                        {/*<TouchableOpacity style={styles.containerRow} onPress={() => openFilters()}>
                                            <Text style={styles.textFilter}>Filtros</Text>
                                            <Ionicons name={'filter-outline'} size={24} color={theme.colors.colorPrimary} />
                                    </TouchableOpacity>*/}
                                    </View>

                                    <FlatList
                                        data={filteredDistributors}
                                        style={{ opacity: locked ? 0.7 : 1, pointerEvents: locked ? 'none' : null }}
                                        horizontal={false}
                                        nestedScrollEnabled={true}
                                        keyExtractor={(item, index) => index.toString()}
                                        showsVerticalScrollIndicator={false}
                                        renderItem={({ item: distributor }) => {
                                            let isSelected = arrayDistributorsSelected.includes(distributor._id)
                                            return (
                                                <DistributorCard
                                                    distributor={distributor}
                                                    isSelected={isSelected}
                                                    setSelected={() => setSelectedDistributors(distributor._id, arrayDistributorsSelected)}
                                                />
                                            )
                                        }}
                                    />
                                    <View style={styles.spacer3} />
                                    <View style={styles.spacer3} />
                                </View>
                            )
                        case STATUS_PERIOD.PERIOD_APROBB:
                        case STATUS_PERIOD.PENDING_APPROBB_WEEKS:
                            return (
                                <CreateScheduleWeek
                                    period={period}
                                    updatePeriod={updatePeriod}
                                    distributor_activities={distributor_activities}
                                    isModerator={false}
                                    indexWeek={selectedWeek}
                                    indexDay={indexDay}
                                    setWeek={(index) => setWeek(index)}
                                    setIndexDay={(index) => setIndexDayFn(index)}
                                    lockExecutive={lockedExecutive}
                                    activities={activities}
                                    monthly_distributor_activities={monthly_distributor_activities}
                                    monthly_activities={monthly_activities}
                                    updateMonthlyDistributorActivities={updateMonthlyDistributorActivities}
                                    updateMonthlyActivities={updateMonthlyActivities}
                                />
                            )
                        case STATUS_PERIOD.PENDING_SET_MONTHS:
                            return (
                                <CreateScheduleMonth
                                    period={period}
                                    updatePeriod={updatePeriod}
                                    isModerator={false}
                                    indexWeek={selectedWeek}
                                    indexDay={indexDay}
                                    setWeek={(index) => setWeek(index)}
                                    setIndexDay={(index) => setIndexDayFn(index)}
                                    lockExecutive={lockedExecutive}
                                    monthly_distributor_activities={monthly_distributor_activities}
                                    monthly_activities={monthly_activities}
                                    updateMonthlyDistributorActivities={updateMonthlyDistributorActivities}
                                    updateMonthlyActivities={updateMonthlyActivities}
                                />
                            )
                        default:
                            return null
                    }
                })()}
            </ScrollView>
            {showButton && (
                <View style={styles.buttonContainer}>
                    {/* Enviar y continuar */}
                    <TouchableOpacity
                        style={buttonEnabled ? styles.mainButton : styles.mainButtonDisabled}
                        onPress={() => {
                            if (period.status != STATUS_PERIOD.PERIOD_APROBB) {
                                sendStep()
                            } else {
                                openBottomSheet(
                                    <SentWeekModal
                                        close={() => sendStep()}
                                        week={period.weeks[selectedWeek].name_week ?? ''}
                                        closeBottomSheet={() => closeBottomSheet(true)}
                                    />,
                                )
                            }
                        }}
                        disabled={buttonEnabled ? false : true}
                    >
                        <Text style={buttonEnabled ? styles.mainButtonText : styles.mainButtonTextDisabled}>{buttonText}</Text>
                    </TouchableOpacity>

                    {/* Siguiente dia */}
                    {[
                        STATUS_PERIOD.PENDING_SET_DISTRIBUTORS,
                        STATUS_PERIOD.PENDING_CHANGE_REQUIRED_DISTRIBUTORS,
                        STATUS_PERIOD.PENDING_APPROBB_DISTRIBUTORS,
                    ].includes(period.status) ? null : (
                        <TouchableOpacity style={[styles.borderButton, styles.containerRow, styles.justifyContent]} onPress={onPressNextDay}>
                            <Text
                                style={[
                                    styles.borderButtonText,
                                    styles.justifyContent,
                                    { opacity: locked ? 0.7 : 1, pointerEvents: locked ? 'none' : null },
                                ]}
                            >
                                {nextDayText}
                            </Text>
                        </TouchableOpacity>
                    )}
                </View>
            )}
        </View>
    )
}

export const validateWeekComplete = (week: Week, periodStatus: number) => {
    let weekComplete = true

    week.days.forEach((day) => {
        if (day.status != 10 && day.status != STATUS_PERIOD.STATUS_DAY_OTHER_MONTH) {
            if (day.day != 5) {
                if (day.distributor != null) {
                    if (day.distributor_activities.length == 0 && day.monthly_distributor_activities.length == 0) {
                        weekComplete = true
                    } else {
                        if (periodStatus != STATUS_PERIOD.PERIOD_APROBB) {
                            day.status = 0
                        }
                    }
                } else {
                    //Sabado
                    if (day.day != 5) {
                        const hasFormId = day.activities.some(
                            (activity) => activity.form_id !== null && activity.form_id !== undefined && activity.status != -1,
                        )
                        const hasFormId2 = day.monthly_activities.some(
                            (activity) => activity.form_id !== null && activity.form_id !== undefined && activity.status != -1,
                        )

                        if (!hasFormId && !hasFormId2) {
                            console.log('3')
                            weekComplete = false
                        } else {
                            if (periodStatus != STATUS_PERIOD.PERIOD_APROBB) {
                                day.status = 0
                            }
                        }
                    } else {
                        if (day.distributor_activities.length == 0 && day.monthly_distributor_activities.length == 0) {
                            console.log('4')
                            weekComplete = false
                        } else {
                            if (periodStatus != STATUS_PERIOD.PERIOD_APROBB) {
                                day.status = 0
                            }
                        }
                    }
                }
            } else {
                if (day.activities.length == 0 && day.monthly_activities.length == 0) {
                    console.log('5')
                    weekComplete = false
                } else {
                    if (periodStatus != STATUS_PERIOD.PERIOD_APROBB) {
                        day.status = 0
                    }
                }
            }
        }
    })
    return weekComplete
}
export const validateWeekCompleteNoActivities = (week: Week) => {
    let weekComplete = true

    week.days.forEach((day) => {
        if (day.status != 10 && day.status != STATUS_PERIOD.STATUS_DAY_OTHER_MONTH) {
            if (day.day != 5) {
                if (day.distributor == null) {
                    if (day.monthly_activities.length > 0) {
                        const hasFormId = day.monthly_activities.some((activity) => activity.form_id !== null && activity.form_id !== undefined)
                        if (!hasFormId) {
                            weekComplete = false
                        }
                    } else {
                        weekComplete = false
                    }
                }
            }
        }
    })
    return weekComplete
}
export const DistributorItem = ({ data, isSelected, setSelected }: { data: Distributor; isSelected: boolean; setSelected: () => void }) => {
    return (
        <TouchableOpacity
            onPress={() => {
                if (data.status == 0) {
                    setSelected()
                }
            }}
            disabled={data.status == 0 ? false : true}
        >
            <View style={styles.containerRow}>
                {(() => {
                    switch (data.status) {
                        case -1:
                            return <Ionicons name={'close'} size={20} color={theme.colors.colorDisapproved} style={styles.marginLeft} />
                        case 0:
                            return (
                                <TouchableOpacity style={styles.checkboxButton} onPress={setSelected}>
                                    <View style={isSelected ? styles.checkboxSelected : styles.checkboxUnselected} />
                                </TouchableOpacity>
                            )
                        case 1:
                        case 2:
                            return <Ionicons name={'checkmark'} size={20} color={theme.colors.colorApproved} style={styles.marginLeft} />
                    }
                })()}

                <DistributorCard distributor={data} isSelected={isSelected} setSelected={() => setSelected()} />
            </View>
        </TouchableOpacity>
    )
}

export const DistributorCard = ({
    distributor,
    isSelected,
    setSelected,
}: {
    distributor: Distributor
    isSelected: boolean
    setSelected: () => void
}) => {
    return (
        <TouchableOpacity
            onPress={() => {
                if (distributor.status == 0) {
                    setSelected()
                }
            }}
            disabled={distributor.status == 0 ? false : true}
        >
            <View style={styles.containerRow}>
                <View
                    style={
                        distributor.status === -1
                            ? styles.cardContainerDisapproved
                            : distributor.status === 1
                            ? styles.cardContainerApproved
                            : isSelected
                            ? styles.cardContainerSelected
                            : styles.cardContainerUnselected
                    }
                >
                    <View style={styles.header}>
                        <View style={styles.containerRow}>
                            <Feather name='truck' size={16} color={theme.colors.darkGray} />
                            <Text style={styles.headerText}>{distributor.name}</Text>
                        </View>
                        <View>
                            {(() => {
                                switch (distributor.status) {
                                    case -1:
                                        return <Ionicons name={'close'} size={20} color={theme.colors.colorDisapproved} style={styles.marginLeft} />
                                    case 0:
                                        return (
                                            <TouchableOpacity style={styles.checkboxButton} onPress={setSelected}>
                                                <View style={isSelected ? styles.checkboxSelected : styles.checkboxUnselected} />
                                            </TouchableOpacity>
                                        )
                                    case 1:
                                    case 2:
                                        return <Ionicons name={'checkmark'} size={20} color={theme.colors.colorApproved} style={styles.marginLeft} />
                                }
                            })()}
                        </View>
                    </View>
                    {distributor.code && (
                        <View style={styles.infoContainer}>
                            <Text style={styles.storecode}>{distributor.code}</Text>
                            {distributor.distance && (
                                <View style={styles.containerData}>
                                    <Text style={styles.separator}> | </Text>
                                    <Feather name='map-pin' size={14} color={theme.colors.textSecondary} />
                                    <Text style={styles.infoText}>{distributor.distance}</Text>
                                </View>
                            )}
                        </View>
                    )}
                    {distributor.address && <Text style={styles.addressText}>{distributor.address}</Text>}

                    <DistributorCardStatustag status={distributor.status} />
                </View>
            </View>
        </TouchableOpacity>
    )
}

export const DistributorCardStatustag = ({ status }) => {
    switch (status) {
        case -1:
            return (
                <View
                    style={[
                        styles.statusModuleList,
                        { borderColor: theme.colors.colorDisapproved, borderWidth: 1.0, backgroundColor: theme.colors.colorDisapproved },
                    ]}
                >
                    <Text style={styles.statusModuleText}>MODIFICADO</Text>
                </View>
            )
        case 0:
            return null
        case 1:
            return (
                <View
                    style={[
                        styles.statusModuleList,
                        { borderColor: theme.colors.colorApproved, borderWidth: 1.0, backgroundColor: theme.colors.colorApproved },
                    ]}
                >
                    <Text style={styles.statusModuleText}>APROBADO</Text>
                </View>
            )
        case 2:
            return (
                <View
                    style={[
                        styles.statusModuleList,
                        { borderColor: theme.colors.colorApproved, borderWidth: 1.0, backgroundColor: theme.colors.colorApproved },
                    ]}
                >
                    <Text style={styles.statusModuleText}>AGREGADO POR GERENTE</Text>
                </View>
            )
        default:
            return null
    }
}

export const DistributorFilters = ({ filterList }) => {
    const [selectedItem, setSelectedItem] = useState<number>(-1)
    const filters = [
        { id: 1, name: 'Orden alfabético A-Z' },
        { id: 2, name: 'Orden alfabético Z-A' },
        // { id: 3, name: 'Menor distancia primero' },
    ]

    return (
        <View>
            <Text style={styles.titleModal}>Orden</Text>
            <View style={styles.spacer2}></View>
            <FlatList
                data={filters}
                horizontal={false}
                keyExtractor={(item) => item.id.toString()}
                showsVerticalScrollIndicator={false}
                renderItem={({ item }) => {
                    let isSelected = selectedItem === item.id
                    return <FilterItem name={item.name} isSelected={isSelected} setSelected={() => setSelectedItem(item.id)} />
                }}
            />
            <TouchableOpacity style={styles.borderButton} onPress={() => filterList(selectedItem)}>
                <Text style={styles.borderButtonText}>Confirmar y filtrar</Text>
            </TouchableOpacity>
        </View>
    )
}

export const FilterItem = ({ name, isSelected, setSelected }: { name: string; isSelected: boolean; setSelected: () => void }) => {
    return (
        <View style={styles.containerOption}>
            <TouchableOpacity style={styles.checkboxButton} onPress={setSelected}>
                <View style={isSelected ? styles.checkboxSelected : styles.checkboxUnselected} />
            </TouchableOpacity>
            <Text style={styles.optionText}>{name}</Text>
        </View>
    )
}

export const DistributorsSentModal = ({ close }) => {
    const { languageFile } = getLanguage()

    let image = require('../../../assets/approvedAgenda.png')
    let title = 'Agenda mensual enviada correctamente'
    let desc = 'Pronto recibirás una notificación con la respuesta de tu gerente. Una vez aprobado el mes, podrás avanzar con la agenda semanal.'
    let button = languageFile.accept

    return (
        <View>
            <Image style={styles.imageAsset} source={image} resizeMode='contain'></Image>
            <Text style={styles.titleText}>{title}</Text>
            <Text style={styles.descriptionText}>{desc}</Text>
            <TouchableOpacity style={styles.borderButton} onPress={close}>
                <Text style={styles.borderButtonText}>{button}</Text>
            </TouchableOpacity>
        </View>
    )
}

export const SentWeekModal = ({ close, week, closeBottomSheet }) => {
    const { languageFile } = getLanguage()

    let image = require('../../../assets/approvedSchedule.png')
    let title = 'Estás enviando ' + week
    let desc =
        'Una vez que completes tu planificación semanal, deberás esperar la aprobación de tu gerente antes de iniciar las actividades. Sólo después de su validación podrás comenzar con las tareas planificadas.'
    let button = 'Confirmar y enviar'

    return (
        <View>
            <Image style={styles.imageAsset} source={image} resizeMode='contain' />
            <Text style={styles.titleText}>{title}</Text>
            <Text style={styles.descriptionText}>{desc}</Text>
            <TouchableOpacity style={styles.borderButton} onPress={() => close()}>
                <Text style={styles.borderButtonText}>{button}</Text>
            </TouchableOpacity>
            <TouchableOpacity style={[styles.borderButton, { borderColor: theme.colors.error }]} onPress={() => closeBottomSheet(true)}>
                <Text style={[styles.borderButtonText, { color: theme.colors.error }]}>{languageFile.cancel}</Text>
            </TouchableOpacity>
            <View style={styles.spacer1}></View>
            <View style={styles.spacer2}></View>
        </View>
    )
}
export const SentMonthModal = ({ close }) => {
    const { languageFile } = getLanguage()

    let image = require('../../../assets/approvedSchedule.png')
    let title = 'Estás enviando tu planificación mensual'
    let desc =
        'Una vez que completes y envíes la planificación mensual, podrás comenzar con la planificación semanal para cada semana del mes. Este paso es esencial para detallar las actividades y organizar tus tareas de forma eficiente.'
    let button = languageFile.accept

    return (
        <View>
            <Image style={styles.imageAsset} source={image} resizeMode='contain' />
            <Text style={styles.titleText}>{title}</Text>
            <Text style={styles.descriptionText}>{desc}</Text>
            <TouchableOpacity style={styles.borderButton} onPress={close}>
                <Text style={styles.borderButtonText}>{button}</Text>
            </TouchableOpacity>
            <View style={styles.spacer1}></View>
            <View style={styles.spacer2}></View>
        </View>
    )
}

export const ConfirmSendWeek = ({ close, week, closeBottomSheet }) => {
    const { languageFile } = getLanguage()

    let image = require('../../../assets/alertSchedule.png')
    let title = 'Estás enviando ' + week
    let desc =
        'Una vez que completes tu planificación semanal, deberás esperar la aprobación de tu gerente antes de iniciar las actividades. Sólo después de su validación podrás comenzar con las tareas planificadas.'
    let button = 'Confirmar y enviar'

    return (
        <View>
            <Image style={styles.imageAsset} source={image} resizeMode='contain'></Image>
            <Text style={styles.titleText}>{title}</Text>
            <Text style={styles.descriptionText}>{desc}</Text>
            <TouchableOpacity style={styles.borderButton} onPress={close}>
                <Text style={styles.borderButtonText}>{button}</Text>
            </TouchableOpacity>

            <TouchableOpacity style={[styles.borderButton, { borderColor: theme.colors.error }]} onPress={() => closeBottomSheet(true)}>
                <Text style={[styles.borderButtonText, { color: theme.colors.error }]}>{languageFile.cancel}</Text>
            </TouchableOpacity>
            <View style={styles.spacer1}></View>
            <View style={styles.spacer2}></View>
        </View>
    )
}

export const ModifiedWeekModal = ({ close }) => {
    const { languageFile } = getLanguage()

    let image = require('../../../assets/retrySchedule.png')
    let title = 'Tienes modificaciones en tu agenda semanal'
    let desc = 'Realiza las modificaciones enviadas. ¡Recuerda tenerlo completo y aprobado para iniciar tu semana!'
    let button = 'Modificar y reenviar ahora'
    let button2 = 'Modificar más tarde'

    return (
        <View>
            <Image style={styles.imageAsset} source={image} resizeMode='contain'></Image>
            <Text style={styles.titleText}>{title}</Text>
            <Text style={styles.descriptionText}>{desc}</Text>
            <TouchableOpacity style={styles.mainButton}>
                <Text style={styles.mainButtonText}>{button}</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.borderButton} onPress={close}>
                <Text style={styles.borderButtonText}>{button2}</Text>
            </TouchableOpacity>
        </View>
    )
}
export const AddVacationModal = ({ close, onSave, customDate, maxDate, initialSelectedDays }) => {
    const { languageFile } = getLanguage()
    const [selectedDays, setSelectedDays] = useState(() => {
        const initialState = {}
        if (initialSelectedDays) {
            initialSelectedDays.forEach((date) => {
                initialState[date] = {
                    selected: true,
                    selectedColor: theme.colors.colorPrimary, // Personalizar el color aquí
                }
            })
        }
        return initialState
    })

    let image = require('../../../assets/alertSchedule.png')
    let title = '¡Agrega tus vacaciones!'
    let desc = 'Selecciona los días que estarás de vacaciones así se contempla en tu agenda mensual.'
    let button = 'Guardar'

    const today = moment().startOf('day')
    const minDate = customDate && moment(customDate).isAfter(today) ? moment(customDate) : today
    const maximumDate = maxDate ? moment(maxDate) : null

    const handleDayPress = (day) => {
        const date = moment(day.dateString)

        // Verifica si la fecha seleccionada está dentro del rango permitido
        if (date.isBefore(minDate) || (maximumDate && date.isAfter(maximumDate))) {
            return
        }

        setSelectedDays((prevSelectedDays) => {
            // Clonar el estado anterior
            const newSelectedDays = { ...prevSelectedDays }

            // Si el día ya está seleccionado, lo quitamos
            if (newSelectedDays[day.dateString]) {
                delete newSelectedDays[day.dateString]
            } else {
                // Si no, lo agregamos con el color que queremos
                newSelectedDays[day.dateString] = {
                    selected: true,
                    selectedColor: theme.colors.colorPrimary,
                }
            }

            return newSelectedDays
        })
    }

    const handleSave = () => {
        const selectedDates = Object.keys(selectedDays)
        console.log('Selected Dates:', selectedDates)
        // Pasar los días seleccionados a través de una prop o usarlos como necesites
        if (onSave) {
            onSave(selectedDates)
        }
    }

    return (
        <View>
            <Text style={styles.titleText}>{title}</Text>
            <Text style={styles.description}>{desc}</Text>
            <Calendar
                onDayPress={handleDayPress}
                markedDates={selectedDays}
                theme={{
                    backgroundColor: 'white',
                    calendarBackground: 'white',
                    textSectionTitleColor: theme.colors.textSecondary,
                    selectedDayBackgroundColor: theme.colors.colorPrimary,
                    selectedDayTextColor: 'white',
                    todayTextColor: theme.colors.textSecondary,
                    todayBackgroundColor: theme.colors.disabled,
                    todayDotColor: 'white',
                    dayTextColor: theme.colors.textPrimary,
                    textDisabledColor: theme.colors.mediumGray,
                    arrowColor: theme.colors.colorPrimary,
                }}
                style={[styles.marginLeft, styles.marginRight]}
                current={minDate.toISOString()}
                minDate={minDate.toISOString()}
                maxDate={maximumDate ? maximumDate.toISOString() : undefined}
            />
            <TouchableOpacity
                style={selectedDays != null ? styles.mainButtonDisabled : styles.mainButton}
                onPress={handleSave}
                disabled={selectedDays != null ? true : false}
            >
                <Text style={selectedDays != null ? styles.mainButtonTextDisabled : styles.mainButtonText}>{button}</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.borderButton} onPress={close}>
                <Text style={styles.borderButtonText}>{languageFile.close}</Text>
            </TouchableOpacity>
        </View>
    )
}
